export default __webpack_public_path__ + "static/media/no-house-picture.b7fed258.svg";